import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import rarrow from "../../../img/rarrow.svg";
import { NewCalendar } from "../../../models/calendar-model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import calendarService from "../../../services/trainer/calendar.service";
import { getNexMonth, getPreviousMonth } from "../../../utils/dates";
import trainerRoutes from "../routes";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const events = [
  {
    title: "NAPTIN Meeting",
    allDay: true,
    start: new Date(2022, 8, 26),
    end: new Date(2022, 8, 26),
  },
  {
    title: "Conference",
    start: new Date(2015, 3, 12, 10, 30, 0, 0),
    end: new Date(2015, 3, 12, 12, 30, 0, 0),
    desc: "Pre-meeting meeting, to prepare for the meeting",
  },
  {
    title: "Vacation",
    start: new Date(2022, 9, 26),
    end: new Date(2022, 9, 26),
  },
];

const TrCourseCalendar = () => {
  const params = useParams();
  const course_id: any = params.course_id;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [availableCourse, setAvailableCourses] = useState<
    IAvailableCourse[] | any
  >();
  const [allEvents, setAllevents] = useState<any[]>();
  const [courseId, setCourseId] = useState("");
  const [user_det, setUser] = useState<any>();
  const [start_date, setStartDate] = useState("");
  const [end_date, setEnddate] = useState("");
  const [event, setEvent] = useState("");
  const [event_description, setDescription] = useState("");
  const [course_topic, setCourseTopic] = useState("");
  const toast = useToast();

  const [reload, setReload] = useState(false);

  const courseName: null | string = localStorage.getItem("courseName");

  const current_date = new Date().toISOString().slice(0, 16);

  const navigate = useNavigate();
  const location = useLocation();

  const [courseTopicss, setCourseTopicss] = useState<any[]>([]);
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });
  const modalSize = useBreakpointValue({ base: "xs", sm: "md", md: "lg" });
  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  // this use effect hook has 2 calls for calendar
  // one for get users calendar events and the other to get calendar events for a course
  // i believe on this page, it should be calendar events fr a particular course
  // i have left get user calendar events here just in case
  useEffect(() => {
    if (course_id) setCourseId(course_id);
    const user = getLocalUserProfile();
    if (user) {
      const date = new Date();
      calendarService
        .getCalendar(user.id, getPreviousMonth(date), getNexMonth(date))
        .then((res) => {
          // console.log(res.data, "Course Calendar");
          const events: any[] = [];
          res.data.forEach((each) => {
            const date = new Date(each.event_datetime);
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const end_date = new Date(each.event_end_datetime);
            const end_year = end_date.getFullYear();
            const end_month = end_date.getMonth();
            const end_day = end_date.getDate();
            const end_hour = end_date.getHours();
            const end_minute = end_date.getMinutes();
            const event_data: any = {
              title: each.event,
              start: new Date(year, month, day, hour, minute, 0),
              end: new Date(
                end_year,
                end_month,
                end_day,
                end_hour,
                end_minute,
                0
              ),
              desc: each.event_description,
            };
            events.push(event_data);
          });
          // setAllevents(events);
        });
      setUser(user);
    }

    coursesService
      .getAvailableCourses()
      .then((response) => {
        const realCourses = response.filter((each) => each.course !== null);

        const available_course = realCourses.find(
          (each) => each.course.uuid == course_id
        );

        if (available_course) {
          const date = new Date();
          calendarService
            .getCourseCalendar(
              available_course?.course.id,
              getPreviousMonth(date),
              getNexMonth(date)
            )
            .then((res) => {
              const events: any[] = [];
              res.data.forEach((each) => {
                const date = new Date(each.event_datetime);
                const year = date.getFullYear();
                const month = date.getMonth();
                const day = date.getDate();
                const hour = date.getHours();
                const minute = date.getMinutes();
                const end_date = new Date(each.event_end_datetime);
                const end_year = end_date.getFullYear();
                const end_month = end_date.getMonth();
                const end_day = end_date.getDate();
                const end_hour = end_date.getHours();
                const end_minute = end_date.getMinutes();
                const event_data: any = {
                  title: each.event,
                  start: new Date(year, month, day, hour, minute, 0),
                  end: new Date(
                    end_year,
                    end_month,
                    end_day,
                    end_hour,
                    end_minute,
                    0
                  ),
                  desc: each.event_description,
                };
                events.push(event_data);
              });
              setAllevents(events);
            });

          setAvailableCourses(available_course);
        }
      })

      .catch((err) => err);
  }, [reload]);

  useEffect(() => {
    coursesService.getTopicsForCourse(course_id).then((res: any) => {
      console.log(res.data, "Hiiii");
      setCourseTopicss(res.data);
    });
  }, [reload]);

  const scheduleCalendar = async () => {
    let scheduleData: NewCalendar;

    if (availableCourse) {
      console.log(availableCourse[0], "available courseeeeee");
      course_topic
        ? (scheduleData = {
            session_id: availableCourse.session_id.toString(),
            term_id: availableCourse.term_id.toString(),
            trainer_id: user_det.uuid,
            course_topic_id: course_topic,
            event: event,
            event_description: event_description,
            event_datetime: start_date,
            event_end_datetime: end_date,
            send_reminder: true,
            status: "new",
          })
        : (scheduleData = {
            session_id: availableCourse.session_id.toString(),
            term_id: availableCourse.term_id.toString(),
            trainer_id: user_det.uuid,
            event: event,
            event_description: event_description,
            event_datetime: start_date,
            event_end_datetime: end_date,
            send_reminder: true,
            status: "new",
          });

      try {
        const schedule_res = await calendarService.setCourseCalendar(
          courseId,
          scheduleData
        );
        if (schedule_res) {
          setDescription("");
          setEvent("");
          setStartDate("");
          setEnddate("");
          setCourseTopic("");
          onClose();
          setReload(!reload);
          toast({
            title: "Schedule Event",
            description: `${schedule_res.message}`,
            status: "success",
          });
        } else {
          toast({
            title: "Schedule Event",
            description: `${schedule_res.message}`,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "Schedule Event",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    }
  };

  return (
    <>
      <TrDashboardHeader />
      <Box
        bg="#F9F8F8"
        minHeight={"100vh"}
        height="auto"
        width="100%"
        pt={"1.5rem"}
      >
        {!showSideNav && (
          <HStack
            overflowX="scroll"
            width={"100%"}
            height={"60px"}
            justifyContent={"space-around"}
            alignItems={"center"}
            fontSize={"13px"}
            padding={"0px 10px"}
            bg="white"
            className="scroll-hidden"
            mt="1.38rem"
            // flex={"no-wrap"}
          >
            {menuLinks.map((link, index) => (
              <React.Fragment key={index}>
                <Link
                  onClick={() => navigate(link.route)}
                  cursor={"pointer"}
                  textAlign={"center"}
                  alignContent={"center"}
                  wordBreak={"keep-all"}
                  height={"60px"}
                  width={"max-content"}
                  borderBottom={
                    activeLink(link.route, link.keywords).borderLeft
                  }
                  borderColor={
                    activeLink(link.route, link.keywords).borderColor
                  }
                  color={activeLink(link.route, link.keywords).textColor}
                >
                  {link.text}
                </Link>
                {index < menuLinks.length - 1 && (
                  <Divider orientation="vertical" height="70%" />
                )}
              </React.Fragment>
            ))}
          </HStack>
        )}
        <Flex
          width="90%"
          mx="auto"
          pb="120px"
          pt={["50px", "60px", "60px", "80px"]}
        >
          {showSideNav && <TrainerSidenav />}
          <VStack
            width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}
            mx="auto"
          >
            <HStack width={"100%"} height={"2rem"}>
              <Text
                as="span"
                fontSize={["16px", "20px"]}
                isTruncated
                maxWidth={["180px", "200px", "350px", "500px"]}
              >
                {courseName && courseName.replaceAll(/"/g, "")}
              </Text>
              <Image src={rarrow} />
              <Text as="span" fontSize={["16px", "16px", "18px", "20px"]} color={"#616161"}>
                Event Scheduler
              </Text>
            </HStack>
            <Box width={"100%"}>
              <Box
                width="100%"
                mx="auto"
                pb={{
                  lg: "200px",
                  md: "150px",
                  sm: "110px",
                  base: "110px",
                }}
                px={{
                  lg: "2.8rem",
                  md: "2.4rem",
                  sm: "2rem",
                  base: "1.4rem",
                }}
                pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                bg="white"
              >
                <Flex justifyContent={"space-between"}>
                  <Text
                    color="#1E1E1E"
                    fontSize={{
                      lg: "28px",
                      md: "20px",
                      sm: "18px",
                      base: "18px",
                    }}
                    pb={["20px", "30px"]}
                    fontWeight="600"
                  >
                    Event Scheduler{" "}
                  </Text>
                  <Button
                    colorScheme={"red"}
                    borderRadius={'2px'}
                    p='7px'
                    size="sm"
                    fontSize={12}
                    onClick={onOpen}
                  >
                    {" "}
                    Schedule Event
                  </Button>
                </Flex>
                <Calendar
                  localizer={localizer}
                  events={allEvents}
                  eventPropGetter={(allEvents: any) => {
                    const backgroundColor = "#EC3337";
                    const color = "white";
                    const overflowX = "scroll";
                    return { style: { backgroundColor, color, overflowX } };
                  }}
                  startAccessor="start"
                  endAccessor="end"
                  style={{ height: 500 }}
                />
              </Box>
            </Box>
          </VStack>
        </Flex>
        <Modal isOpen={isOpen} scrollBehavior={"inside"} onClose={onClose} size={modalSize}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Schedule Event</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <form action="">
                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                    Event Title
                  </FormLabel>
                  <Input
                    bg="inputText.500"
                    placeholder="Enter title"
                    value={event}
                    name="event"
                    onChange={(event) => setEvent(event.target.value)}
                    fontSize={12}
                  />
                </FormControl>
                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                    Event Description
                  </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="100px"
                    name="description"
                    onChange={(event) => setDescription(event.target.value)}
                    value={event_description}
                  />
                </FormControl>
                <HStack mb="15px">
                  <FormControl>
                    <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                      Start Date
                    </FormLabel>
                    <Input
                      bg="inputText.500"
                      type={"datetime-local"}
                      placeholder="Enter title"
                      value={start_date}
                      min={current_date}
                      name="startdate"
                      onChange={(event) => setStartDate(event.target.value)}
                      fontSize={12}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                      End Date
                    </FormLabel>
                    <Input
                      bg="inputText.500"
                      type={"datetime-local"}
                      placeholder="Enter title"
                      value={end_date}
                      name="enddate"
                      onChange={(event) => setEnddate(event.target.value)}
                      fontSize={12}
                    />
                  </FormControl>
                </HStack>

                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                    Course Topic
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="select topic"
                    value={course_topic}
                    name="coursetopic"
                    onChange={(event) => setCourseTopic(event.target.value)}
                    fontSize={12}
                    color="brand.subtitle"
                  >
                    {courseTopicss.length > 0 ? (
                      courseTopicss.map((each) => (
                        <option key={each.id} value={each.id}>
                          {each.title}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No Topic for this course
                      </option>
                    )}
                  </Select>
                  <FormErrorMessage fontSize={12}></FormErrorMessage>
                </FormControl>
              </form>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="red"
                variant="ghost"
                mr={3}
                onClick={onClose}
              >
                Close
              </Button>
              <Button
                size={"sm"}
                fontSize="12px"
                colorScheme={"red"}
                onClick={() => scheduleCalendar()}
              >
                Schedule
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default TrCourseCalendar;
